import React from 'react';
import { FileQuestion } from 'lucide-react';

export const BoardNotFoundFallback = ({ onGoHome }: { onGoHome: () => void }) => (
    <div className="h-full w-full flex items-center justify-center bg-slate-50 dark:bg-slate-950">
        <div className="text-center space-y-4">
            <div className="w-16 h-16 mx-auto text-slate-400">
                <FileQuestion className="w-full h-full" />
            </div>
            <h2 className="text-xl font-semibold text-slate-700 dark:text-slate-300">
                Board Not Found
            </h2>
            <p className="text-slate-500 dark:text-slate-400 max-w-md">
                The board you're looking for doesn't exist or you don't have access to it.
            </p>
            <button
                onClick={onGoHome}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors font-medium"
            >
                Go to Home
            </button>
        </div>
    </div>
);
